import React from "react";
import { Link, useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";

export default function AdminBillingCodes() {
  const history = useHistory();

  const table_columns = [
    { header: "Code", key: "code" },
    { header: "Description", key: "description" },
  ];

  const table_actions = (billing_code) => (
    <ul id="action-menu" className="action-menu">
      <Link to={"/admin-billing-code-form#billing_code_id=" + billing_code.id}>
        {" "}
        <i className="bi bi-pencil"></i>Edit
      </Link>
    </ul>
  );

  function onClickAdmin(ev) {
    ev.stopPropagation();
    history.push("/admin");
  }

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={onClickAdmin}>
          <i className="bi bi-chevron-left"></i> Admin
        </button>
        <h1>Billing Codes</h1>
        <i className="spacer" />
      </div>
      <div className="invoice-categories">
        <DataTable
          query="admin/billing_codes"
          cols={table_columns}
          actions={table_actions}
          empty="No Billing Codes Found"
        />
      </div>
    </div>
  );
}
